import axios from 'axios'


//export const baseUrl      = `http://localhost/seller-center-back`
export const baseUrl = process.env.NODE_ENV === 'production' ?
    `https://apisc.farmaonline.com/` :
    `https://apisc.farmaonline.com/`
// export const nodeServer     = `https://apisc.farmaonline.com/`
export const fileUrl = `https://apisc.farmaonline.com/`
export const AUTH = `${baseUrl}auth`
export const uploadUrl = `${baseUrl}sellercomisiones/subirComprobante`
export const uploadOcr = `${baseUrl}sellercomisiones/subirComprobanteOCR`
export const updateFileUrl = `${baseUrl}sellercomisiones/cambiarComprobanteLiq`
export const updateUrl = `${baseUrl}seller/updateLiquidacion`
export const updateUrlTkt = `${baseUrl}sellercomisiones/subirLiquidacionTicket`
export const urlUploadLogo = `${baseUrl}seller/guardarDatosTienda`
export const Notificaciones = `${baseUrl}sellernotificaciones`
export const urlNotificacion = `${baseUrl}sellernotificaciones/guardarImgNotificacion`

export const FA = `vcerrarFarma`
export const SC = `seller`
export const SC_prueba = `sellerPrueba`
export const SCA = `selleradmin` //admin controller
export const SP = `sellerpedidos` //admin controller
export const LIQ = 'sellercomisiones'
export const GRUPOS = 'sellergrupos'
export const PV = 'selleradminpostventa'
export const INFORMES = 'sellerinformes'
export const FARMACIA = 'farmacia'
export const FOLIQ = 'vtexliquidaciones'
export const PDR = 'farmaciasFO'
export const ROBOT = 'robotLiquidaciones'

export const TTO = 'https://tto.suizoargentina.com/dispensa'

export const TE = 'https://api.treggo.co/1'
export const ES = `vpedidoFol`
export const uploadUrlFile = `${baseUrl}vcerrarFarma/subirArchivos`


// export const imgUrl = ``
export const HTTP = axios.create({
    baseURL: baseUrl,
    headers: {
        'Authorization': `Bearer ${window.sessionStorage.getItem('token')}`,
        // 'Accept': 'application/json',
        // 'Content-Type': 'application/json',
        // 'Content-Type': 'multipart/form-data' ,
        // 'Content-Type': 'application/x-www-form-urlencoded'

    },
    crossDomain: true
})